var React = require('react');

function ToteBag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 9h14l-.6 11.2a1 1 0 0 1-1 .8H6.6a1 1 0 0 1-1-.8z","key":0}),React.createElement("path",{"d":"M8.5 9V6.5a3.5 3.5 0 0 1 7 0V9","key":1})]);
}

ToteBag.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = ToteBag;

ToteBag.default = ToteBag;
